import React, { useEffect, useState } from "react";
import CustomContainer from "../../components/common/CustomContainer"
import { getDocConsultacyApi } from "../../utils/api/services";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { RootState } from "../../utils/store";
import CustomPieChart from "../../components/common/CustomPieChart";
import XBarChart from "../../components/common/XBarChart";
import { FormGroup, FormLabel } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import moment from "moment";

const DoctorConsultation = () => {
    const [NoOfEmpTakenCall, setNoOfEmpTakenCall] = useState<PieDataTypes[]>([]);
    const [specialtyChartData, setSpecialtyChartData] = useState<{ name: string, value: number }[]>([])
    const [filterData, setFilterData] = useState<filterTypes>({
        from_date: '',
        to_date: ''
    })
    const { LoginData } = useSelector((state: RootState) => state.auth);

       const handleDateFilters: HandleDateChangeType = (date, name) => {
            const formattedDate = moment(date).format('YYYY-MM-DD');
            if (!date) {
                setFilterData({ ...filterData, [name]: '' });
            }
            else {
                setFilterData({ ...filterData, [name]: formattedDate });
            }
        };
    
    const fetchConsultData = async (data: { companyId: number, from_date?: string, to_date?: string }) => {
        try {
            const result = await getDocConsultacyApi(data);
            if (result?.success) {
                const NoOfEmpTaken = [
                    { name: "Call Taken", value: result?.data?.noOfEmpTakenCall?.call_taken, color: "#54a276" },
                    { name: "Call Not Taken", value: result?.data?.noOfEmpTakenCall?.call_not_taken, color: "#aa2626" },
                ]
                setNoOfEmpTakenCall(NoOfEmpTaken);
                const specialtyData = (result?.data?.speciallityWise as Speciality[])?.map((item) => {
                    return {
                        name: item?.speciality_name,
                        value: item?.cnt,
                    }
                })
                setSpecialtyChartData(specialtyData)
            }
        } catch (error: any) {
            toast.error(error?.data?.errors || error?.message);
        }
    }

    useEffect(() => {
        if (LoginData) {
            fetchConsultData({ companyId: LoginData?.companyId, from_date: filterData?.from_date, to_date: filterData?.to_date })
        }
    }, [filterData])
    return (
        <CustomContainer>
            <div className={'AllPageMain'}>
                <div className={'HeadAndButton'}>
                    <h2>Doctor Consultation</h2>
                </div>
                <div className="flex justify-end items-center gap-6">
                    <FormGroup className="customFormGroup">
                        <FormLabel className="customFormLabel">From Date</FormLabel>
                        <DatePicker
                            className="custumTextField profileInput"
                            value={filterData?.from_date ? moment(filterData?.from_date, 'YYYY-MM-DD') : null}
                            maxDate={moment(new Date(), 'YYYY-MM-DD')}
                            format="YYYY-MM-DD"
                            onChange={(date) => handleDateFilters(date ? moment(date)?.toDate(): null, 'from_date')}
                            slotProps={{ field: { clearable: filterData?.from_date ? true : false } }}
                        />
                    </FormGroup>
                    <FormGroup className="customFormGroup">
                        <FormLabel className="customFormLabel">To Date</FormLabel>
                        <DatePicker
                            className="custumTextField profileInput"
                            value={filterData?.to_date ? moment(filterData?.to_date, 'YYYY-MM-DD') : null}
                            maxDate={moment(new Date(), 'YYYY-MM-DD')}
                            minDate={moment(filterData?.from_date, 'YYYY-MM-DD')}
                            format="YYYY-MM-DD"
                            disabled={filterData?.from_date === "" ? true : false}
                            onChange={(date) => handleDateFilters(date ? moment(date)?.toDate() : null, 'to_date')}
                            slotProps={{ field: { clearable: filterData?.from_date ? true : false } }}
                        />
                    </FormGroup>
                </div>
                <div>
                    {/* <div className="flex justify-end gap-4">
                        {["Week", "Month", "Year"].map((filter) => (
                            <button key={filter} onClick={() => setTimeFilter(filter)} className={`px-4 py-2 border rounded-lg ${timeFilter === filter ? "bg-blue-500 text-white" : "bg-white text-black border-gray-300"}`}>
                                {filter}
                            </button>
                        ))}
                    </div> */}
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6 p-6">
                        <CustomPieChart chartData={NoOfEmpTakenCall} title={"Number of Employees"} />
                        <XBarChart chartData ={specialtyChartData} title="Specialties" />
                    </div>
                </div>
            </div>
        </CustomContainer>
    )
}

export default DoctorConsultation